jQuery(document).ready(function ($) {

	const youTubeContainer = $(".js-video-container");

	if ("IntersectionObserver" in window) {
		let observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					loadYouTubeVideo($(entry.target));
					observer.unobserve(entry.target);
				}
			});
		});

		youTubeContainer.each(function () {
			observer.observe(this);
		});
	} else {
		// Fallback for browsers that do not support Intersection Observer
		youTubeContainer.each(function () {
			loadYouTubeVideo($(this));
		});
	}

	function loadYouTubeVideo($container) {
		const videoId = $container.data("video-id"),
			iframe = $("<iframe>", {
			src: "https://www.youtube-nocookie.com/embed/" + videoId + "?rel=0&showinfo=0&autoplay=1",
			frameborder: 0,
			allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
			allowfullscreen: true,
		});
		var iframeWrapper = $("<div class=\"row-video__iframe\"></div>").append(iframe);
		$container.empty().append(iframeWrapper);
	}

	// Add click event to replace thumbnail with video iframe
	youTubeContainer.on("click", function () {
		const $this = $(this);

		if (!$this.find("iframe").length) {
			loadYouTubeVideo($this);
		}
	});

	$('.js-play-video').on('click', function() {
		const $container = $(this).closest(".js-video-container");

		if (!$container.find('iframe').length) {
			loadYouTubeVideo($container);
		}

		return false;
	});

});